export const aboutEs = {
  embed: {
    cards: [
      { title: 'Nuestra Misión', desc: 'Ofrecer la mejor experiencia en compra y venta de vehículos, con transparencia y confianza en cada operación.' },
      { title: 'Confianza', desc: 'Nos destacamos por la honestidad y transparencia en cada transacción. Tu satisfacción es nuestra prioridad.' },
      { title: 'Excelencia', desc: 'Mejora continua en nuestros procesos para garantizar un servicio de primer nivel a todos nuestros clientes.' },
    ],
    teamTitle: 'Nuestro Equipo',
    teamSubtitle: 'Conoce a las personas detrás de nuestra automotora',
    members: [
      { name: 'Nombre del Gerente', role: 'Gerente General' },
      { name: 'Nombre del Vendedor', role: 'Ventas' },
      { name: 'Nombre del Asesor', role: 'Atención al Cliente' },
    ],
  },
};
